import { UserTime03Icon } from '@hugeicons/core-free-icons';
import { useTranslation } from 'react-i18next';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button } from 'components/FormComponents';

const formatTime = milliseconds => {
  const totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes} min ${String(seconds).padStart(2, '0')} secs`;
};

export const SessionTimeoutModal = ({
  visible,
  msRemaining,
  onStaySignedIn,
  onSignOut,
  staySignedInLoading,
}) => {
  const { t } = useTranslation();
  const time = formatTime(msRemaining || 0);

  return (
    <AnimatedModal
      visible={visible}
      xSmall
      dataTestId="session-timeout-modal"
      title={t('sessionTimeout.title')}
      icon={UserTime03Icon}
      oldIconLibrary={false}
      noHeaderBorder
      noClose
      actionButtons={
        <div className="flex flex-row gap-4 items-center p-4 w-full">
          <Button
            className="flex-1"
            type="secondary-reverse"
            dataTestId="session-timeout-sign-out-button"
            onClick={onSignOut}>
            {t('sessionTimeout.signOut')}
          </Button>
          <Button
            className="flex-1"
            type="primary"
            disabled={staySignedInLoading}
            dataTestId="session-timeout-stay-signed-in-button"
            onClick={onStaySignedIn}>
            {t('sessionTimeout.staySignedIn')}
          </Button>
        </div>
      }>
      <div className="flex flex-col gap-4">
        <p className="text-neutral-6 text-[14px]">{t('sessionTimeout.body')}</p>
        <div className="rounded-3xl bg-neutral-2 text-center p-8 border border-neutral-4">
          <span
            className="text-6xl font-light text-primary-5"
            data-testid="session-timeout-countdown">
            {time}
          </span>
        </div>
        <p className="text-neutral-6 text-[14px]">{t('sessionTimeout.instruction')}</p>
      </div>
    </AnimatedModal>
  );
};
